import React from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { SEO } from '../../../../components/Seo/seo'
import { FormattedMessage, useIntl } from 'react-intl'
import Layout from '../../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../../routes'
import { editPlan } from '../../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { PlanProvider } from '../../../../PlanContext'
import { FormLoader } from '../../../../components/Loader/FormLoader'
import PlanEditContent from '../../../../components/Dashboard/Subscription/PlanEditContent'


const SinglePlanEdit = () => {
  let { id } = useParams()
  const intl = useIntl()
  return (
    <>
      {!!id && !!parseInt(id) ? <>
          <SEO title={intl.formatMessage({ id: 'Plans.List.EditPlan.Title' })}
               pathname={window.location.origin}
               titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
               image={editPlan.image}
               description={intl.formatMessage({ id: 'Plans.List.EditPlan.Title' })}
          />
          <AuthenticatedUserConsumer>
            {({ userDataLoading, userData, handleNotificationCall }) => (
              <>
                {!!userDataLoading && <FormLoader loading={true}/>}
                {!!Object.keys(userData).length &&
                <>
                  {!!userData.is_admin ? <Layout content={
                    <PlanProvider pageAction={'edit'} pid={id}
                                     handleNotificationCall={handleNotificationCall}>
                      <PlanEditContent pageTitle={<FormattedMessage id='Plans.List.EditPlan.Title'/>}/>
                    </PlanProvider>
                  }/> : (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
                  }
                </>
                }
              </>
            )}
          </AuthenticatedUserConsumer>
        </> :
        <Redirect to={NamedRoutes.subscription.plan.list}/>
      }
    </>
  )
}

export default SinglePlanEdit

